import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 6"
}, n = /* @__PURE__ */ o("path", {
  stroke: "currentColor",
  "stroke-width": "1.5",
  d: "M3.5 5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm7 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm7 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
}, null, -1), c = [
  n
];
function s(l, a) {
  return e(), t("svg", r, [...c]);
}
const i = { render: s };
export {
  i as default,
  s as render
};
